import { IModalState } from './modal-state.interface';

export const MODAL_STATE_DEFAULTS: IModalState = {
  route: null,
  data: null,
  onClose: null,
};
